"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const IconClose_1 = __importDefault(require("../../assets/icons/IconClose"));
const helpCenter_1 = require("../../helpers/links-builders/helpCenter");
const styles_styled_1 = require("./styles.styled");
const helpers_1 = require("../../helpers");
const AppContextProvider_1 = require("../../contexts/AppContextProvider");
const IconRightArrowHead_1 = __importDefault(require("../../assets/icons/IconRightArrowHead"));
const slrActions_1 = require("../../GTMs/actions/slrActions");
const constants_1 = require("../../constants");
const auth_1 = __importDefault(require("../../auth"));
const loggingActions_1 = require("../../libs/logging/helpers/loggingActions");
const SsoHeader = ({ setIsSsoModalOpen }) => {
    var _a, _b;
    const { translations, country, isDesktop, isMobile, fullPage, locale } = (0, styled_components_1.useTheme)();
    const baseDomain = (_a = auth_1.default === null || auth_1.default === void 0 ? void 0 : auth_1.default.getInstance()) === null || _a === void 0 ? void 0 : _a.getBaseDomain();
    const { flowState, dispatch } = (0, AppContextProvider_1.useSsoContext)();
    let baseDomain2 = (_b = auth_1.default === null || auth_1.default === void 0 ? void 0 : auth_1.default.getInstance()) === null || _b === void 0 ? void 0 : _b.getBaseDomain();
    if (baseDomain2.startsWith("sso.")) {
        baseDomain2 = baseDomain2.slice(4);
    }
    const urlToOS = `https://${country}.${baseDomain2}/${locale}`;
    if (isDesktop && flowState.screenType === "LOGIN_SCREEN")
        return null;
    const onClose = () => {
        var _a;
        if (window.location.href.includes("sso.")) {
            window.location.href = urlToOS;
        }
        else {
            window[constants_1.ON_CONTINUE_CB] && window[constants_1.ON_CONTINUE_CB]();
            if ((_a = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _a === void 0 ? void 0 : _a.id) {
                document.dispatchEvent(new CustomEvent(constants_1.LOGIN_SUCCESS_CONSTANT));
            }
            (0, slrActions_1.gtmCloseBtn_SLRMainScreen)();
            if (fullPage) {
                // this back for full page login
                window.history.back();
                return;
            }
            setIsSsoModalOpen(false);
            document.dispatchEvent(new CustomEvent(constants_1.LOGIN_SUCCESS_CONSTANT, {
                detail: { message: "close" }
            }));
        }
    };
    return ((0, jsx_runtime_1.jsx)(styles_styled_1.SsoHeaderCont, Object.assign({ id: "SsoHeader" }, (0, helpers_1.classNames)("font-17 whiteBg sticky", isMobile && "p-16", isDesktop && "pt-16 pb-16 mb-16"), { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)("flex alignItems flexSpaceBetween", isDesktop && "width-1200 m-auto"), { children: [(0, helpers_1.getNavigateType)(flowState === null || flowState === void 0 ? void 0 : flowState.screenType) === "close" && ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: "flex alignItems justifyContent pointer", "aria-label": "Close", onClick: () => {
                        (0, loggingActions_1.authenticateCloseLoginScreen)();
                        onClose();
                    } }, { children: (0, jsx_runtime_1.jsx)(IconClose_1.default, {}) }))), (0, helpers_1.getNavigateType)(flowState === null || flowState === void 0 ? void 0 : flowState.screenType) === "back" && ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: "flex alignItems justifyContent pointer", "aria-label": "Back", onClick: () => {
                        (0, slrActions_1.gtmBackBtn_SLRScreen)();
                        dispatch({
                            screenType: (0, helpers_1.getPrevScreen)(flowState.screensFlow, flowState.screenType),
                        });
                    } }, { children: (0, jsx_runtime_1.jsx)(IconRightArrowHead_1.default, { fill: "#000" }) }))), isDesktop && ((0, jsx_runtime_1.jsx)("img", { src: "https://opensooqui2.os-cdn.com/prod/public/images/openSooqLogo/openSooqLogoDesktop.svg", alt: "OpenSooq - \u0627\u0644\u0633\u0648\u0642 \u0627\u0644\u0645\u0641\u062A\u0648\u062D", width: "100", height: "36" })), (0, jsx_runtime_1.jsx)("a", Object.assign({ href: (0, helpCenter_1.linkToContactUs)(country, baseDomain, fullPage), onClick: slrActions_1.gtmHelpBtn_SLRMainScreen }, { children: translations.help }))] })) })));
};
exports.default = SsoHeader;
